const replaceVariables = (str, variables) => {
  if (typeof(variables) === 'object') {
    for (const variable in variables) {
      if (str.includes(':' + variable)) {
        str = str.replace(':' + variable, `${variables[variable]}`);
      }
    }
  }

  return str;
}

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        __() {
          return (key, variables) => {
            const translationString = this.$localization.translations[key];

            if (translationString && typeof(translationString) === 'string') {
              return replaceVariables(translationString, variables);
            }

            return translationString;
          };
        },
      },
    });
  },
};
